<div class="error-panel-container d-flex" [ngClass]="class">{{ errorMsg }}</div>
